export var CONSTANTS = {
    ROUTES: {
        DISPLAY: '/pid-cms-display',
        CAMPAIGNS: '/pid-cms-campaigns',
        IMAGE_LIBRARY: '/pid-cms-image-library',
        BROADCAST_TEXT_MESSAGE: '/pid-cms-broadcast-text-message',
        GEOFENCE: '/pid-cms-geofence',
        ROUTE: '/pid-cms-route',
        STOP: '/pid-cms-stop',
    },
};
